import { RecentCheckedItemJsEnv } from "./recent_checked_item_js_env";

export class RecentCheckedItem {
  constructor(private model: RecentCheckedItemJsEnv) {
    this.model = { ...model };
  }

  getModel(): RecentCheckedItemJsEnv {
    return {
      ...this.model
    };
  }

  updateModel(supplierId: string, catalogItemCode: string) {
    this.model.recentCheckedItems = this.model.recentCheckedItems.filter(recentCheckedItem =>
      recentCheckedItem.supplierId + recentCheckedItem.catalogItemCode !== supplierId + catalogItemCode)
  }
}
